import { Ship, ArrowUpRight } from "lucide-react";
import { Layout } from "@/components/layout/Layout";
import { PageHero } from "@/components/layout/PageHero";
import { SectionHead, Reveal } from "@/components/layout/Motion";
import { LeadForm } from "@/components/layout/LeadForm";
import { CallCta, PaymentOptions } from "@/components/layout/CtaBlocks";
import { CRUISE_DESTINATIONS } from "@/data/content";
import { PHONE_TEL } from "@/lib/site";

const FIELDS = [
  { name: "destination", label: "Destination", options: ["Caribbean", "Alaska", "Bahamas", "Mediterranean", "Hawaii", "Other"], required: true },
  { name: "port", label: "Departure port", options: ["Miami", "Fort Lauderdale", "Port Canaveral", "Galveston", "Seattle", "Los Angeles", "New York", "Other"] },
  { name: "line", label: "Cruise line", options: ["Royal Caribbean", "Carnival", "Norwegian", "Princess", "Celebrity", "MSC", "Holland America", "No preference"] },
  { name: "month", label: "Sailing month", type: "month" },
  { name: "name", label: "Full name", required: true },
  { name: "phone", label: "Phone number", type: "tel", required: true },
];

export default function Cruises() {
  return (
    <Layout>
      <PageHero testId="cruises-hero" image="/img/hero-cruise.jpg" eyebrow="Cruises" icon={Ship} line1="Find your cruise —" line2="every major line." text="Cruise experts help you pick the right ship, cabin and deck. Balcony upgrades, group sailings and pre-cruise hotel bundles all handled in one call."
        secondary={{ href: "#plan-cruise", label: "Plan your cruise" }} />
      <section className="bg-white py-16">
        <div className="mx-auto max-w-[1320px] px-4 sm:px-8">
          <SectionHead title="Popular cruise destinations" text="Tap a destination and our team will check sailing dates for you." />
          <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-5">
            {CRUISE_DESTINATIONS.map(([n, img], i) => (
              <Reveal key={n} delay={i * 0.05}>
                <a href={PHONE_TEL} data-testid={`cruise-dest-${n.toLowerCase()}`} className="group relative block aspect-[3/4] overflow-hidden rounded-2xl">
                  <img src={img} alt={n} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/10 to-transparent" />
                  <div className="absolute inset-x-0 bottom-0 p-4 text-white"><p className="font-display text-lg font-bold">{n}</p><p className="flex items-center gap-1 text-xs text-white/85">Explore cruise options <ArrowUpRight className="h-3 w-3" /></p></div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section id="plan-cruise" className="bg-sand py-16">
        <div className="mx-auto grid max-w-[1320px] gap-10 px-4 sm:px-8 lg:grid-cols-2">
          <SectionHead title="Plan your cruise" text="Choose your preferred destination, port and cruise line. We’ll call to check sailing dates, cabin options and current pricing. Selections are preferences, not confirmed availability." />
          <Reveal className="rounded-2xl border border-slate-200 bg-white p-6 sm:p-8"><LeadForm testId="cruise-form" source="cruises" fields={FIELDS} submitLabel="Request a call back" /></Reveal>
        </div>
      </section>
      <CallCta title={["Ready to set sail?", "Let’s talk cruises."]} text="Tell us your dates and dream itinerary. We’ll compare ships and cabins together." />
      <PaymentOptions />
    </Layout>
  );
}
